module.exports = __webpack_public_path__ + "media/pdf/sac_logo_cmyk_it_pos.opti-96e19209.jpg";